import { createMuiTheme } from "@material-ui/core/styles";

const theme = createMuiTheme({
  shadows: ["none"] as any,
  props: {
    MuiButtonBase: {
      disableRipple: true,
    },
  },
  palette: {
    background: {
      default: "#F7F7F7",
    },
    ice: {
      main: "#e8e9e9",
    },
    blueGrey: {
      main: "#d2d3d5",
    },
    coolGrey: {
      main: "#a6a8aa",
    },
    battleshipGrey: {
      main: "#797c80",
    },
    gunmetal: {
      main: "#4d5155",
    },
    charcoalGrey: {
      main: "#363a40",
    },
    dark: {
      main: "#20252b",
    },
    primary: {
      main: "#1A63AB",
    },
    secondary: {
      main: "#1EA8A3",
    },
    error: {
      main: "#DB1C1C",
    },
    warning: {
      main: "#FFC66F",
    },
    success: {
      main: "#1EA8A3",
    },
  },
  typography: {
    fontSize: 14,
    fontFamily: [
      "Lota Grotesque",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    body1: {
      fontSize: 14,
      fontWeight: "normal",
    },
    body2: {
      fontSize: 14,
      fontWeight: 600,
    },
    button: {
      lineHeight: 1,
      fontWeight: 700,
      letterSpacing: 1.6,
    },
    h1: {
      fontWeight: 600,
      fontSize: 64,
    },
    h2: {
      fontWeight: 600,
      fontSize: 32,
    },
    h3: {
      fontWeight: 600,
      fontSize: 24,
    },
    h4: {
      fontWeight: 600,
      fontSize: 16,
    },
    h5: {
      fontWeight: 700,
      fontSize: 14,
    },
    h6: {
      fontWeight: 700,
      fontSize: 12,
    },
  },
  overrides: {
    MuiCssBaseline: {
      "@global": {
        body: {
          fontFamily: [
            "Lota Grotesque",
            "BlinkMacSystemFont",
            '"Segoe UI"',
            "Roboto",
            '"Helvetica Neue"',
            "Arial",
            "sans-serif",
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
          ].join(","),
        },
      },
    },
    MuiPickersCalendar: {
      week: {
        "& div": {
          border: "1px solid #e8e9e9",
          borderRightWidth: 0,
          borderBottomWidth: 0,
          "&:last-child": {
            borderRight: "1px solid #e8e9e9",
          },
        },
        "&:last-child": {
          "& div": {
            borderBottom: "1px solid #e8e9e9",
          },
        },
      },
      transitionContainer: {
        minHeight: "auto",
        height: "100%",
        maxHeight: "215px",
        marginTop: "6px",
        marginBottom: "16px",
        overflow: "hidden",
        "&& > div": { position: "static" },
      },
    },
    MuiPickersCalendarHeader: {
      daysHeader: {
        padding: "0 10px",
      },
      switchHeader: {
        marginTop: 8,
        marginBottom: 16,
      },
      dayLabel: {
        margin: 0,
        fontSize: "12px",
        fontWeight: "bold",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: "19px",
        letterSpacing: 1,
        textAlign: "center",
        color: "#797c80",
      },
    },
    MuiPickersBasePicker: {
      pickerView: {
        maxWidth: 245,
        minWidth: 245,
        minHeight: "unset",
      },
    },
    MuiPickersDay: {
      day: {
        borderRadius: 0,
        margin: 0,
        color: "#20252b",
        width: 32,
        height: 32,
        letterSpacing: 1,
        "& p": {
          fontSize: "12px",
          fontWeight: "normal",
          lineHeight: "1.58",
        },
      },
      daySelected: {
        borderRadius: 0,
        "& p": {
          fontWeight: "bold",
        },
      },
      "&.MuiTypography-body2": {
        fontWeight: "500!important",
      },
    },
    MuiTableRow: {
      root: {
        height: "100%",
      },
      head: {
        height: "100%",
      },
    },
  },
});

export default theme;
